module.exports = __webpack_public_path__ + "img/0dd597d1c6e93a4311dbffffb2247f16.svg";